/* Spinningstickers: "Select your bike" för Design-On-Demand-kit.
   Tre beroende dropdowns (Brand -> Model -> Year) + ev. fritextfält Color, som
   Quickbutiks sida. Valen skickas som radegenskaper properties[Brand|Model|Year|Color]
   via form-attributet på fälten, så de följer med i varukorgen och ordern.
   Visar även undantaget från ångerrätten med länk till returpolicyn.
   Styrs av window.SS_DOD (sätts i theme.liquid ur produktens metafält):
     { kat: "street"|"mx"|"atv", color: "none"|"optional"|"required", data: <asset-url> } */
(function () {
  var cfg = window.SS_DOD;
  /* Utökad 2026-10-09: samma väljare används för Model Name-, Your Text- och universella fälgkit.
     cfg.kat kan saknas (bara textruta), cfg.text = "modellnamn"|"text"|"anvandarnamn" ger en
     obligatorisk textruta, cfg.marke förväljer märket, cfg.notice visar ångerrättsundantaget.
     Val "Annan modell" ger fritext properties[Bike] i stället för Brand/Model/Year. */
  if (!cfg || (!cfg.kat && !cfg.text)) return;
  /* Texter per språk (html lang). Radegenskapernas namn (Brand/Model/Year/Color) är
     alltid engelska — de läses av ordervyn och v14. */
  var ALLA_TXT = {
    en: {
      heading: "Select your bike", brand: "Brand", model: "Model", year: "Year",
      color: "Color", colorHint: "Optional: base color of your bike, or wishes for the design",
      pickBrand: "Select brand", pickModel: "Select model", pickYear: "Select year",
      missing: "Please select brand, model and year first.",
      missingColor: "Please fill in the color.",
      notice: "Made to your choices. Personalised products are not covered by the right of withdrawal, so please check your choices carefully.", policy: "Return policy"
    },
    sv: {
      heading: "Välj din motorcykel", brand: "Märke", model: "Modell", year: "Årsmodell",
      color: "Färg", colorHint: "Valfritt: motorcykelns grundfärg eller önskemål om designen",
      pickBrand: "Välj märke", pickModel: "Välj modell", pickYear: "Välj årsmodell",
      missing: "Välj märke, modell och årsmodell först.",
      missingColor: "Fyll i färgen.",
      notice: "Tillverkas efter dina val. Personligt anpassade produkter omfattas inte av ångerrätten, så kontrollera valen noga.", policy: "Returpolicy"
    },
    fr: {
      heading: "Choisissez votre moto", brand: "Marque", model: "Modèle", year: "Année",
      color: "Couleur", colorHint: "Facultatif : couleur de base de votre moto ou souhaits pour le design",
      pickBrand: "Choisir la marque", pickModel: "Choisir le modèle", pickYear: "Choisir l'année",
      missing: "Veuillez d'abord choisir la marque, le modèle et l'année.",
      missingColor: "Veuillez indiquer la couleur.",
      notice: "Fabriqué selon vos choix. Les produits personnalisés sont exclus du droit de rétractation, vérifiez donc soigneusement vos choix.", policy: "Politique de retour"
    },
    de: {
      heading: "Wähle dein Motorrad", brand: "Marke", model: "Modell", year: "Baujahr",
      color: "Farbe", colorHint: "Optional: Grundfarbe deines Motorrads oder Wünsche zum Design",
      pickBrand: "Marke wählen", pickModel: "Modell wählen", pickYear: "Baujahr wählen",
      missing: "Bitte zuerst Marke, Modell und Baujahr wählen.",
      missingColor: "Bitte die Farbe angeben.",
      notice: "Wird nach deinen Angaben gefertigt. Personalisierte Produkte sind vom Widerrufsrecht ausgeschlossen, prüfe deine Auswahl daher sorgfältig.", policy: "Rückgaberichtlinie"
    },
    es: {
      heading: "Elige tu moto", brand: "Marca", model: "Modelo", year: "Año",
      color: "Color", colorHint: "Opcional: color base de tu moto o deseos para el diseño",
      pickBrand: "Elige la marca", pickModel: "Elige el modelo", pickYear: "Elige el año",
      missing: "Elige primero la marca, el modelo y el año.",
      missingColor: "Indica el color.",
      notice: "Se fabrica según tus elecciones. Los productos personalizados están excluidos del derecho de desistimiento, así que revisa bien tus elecciones.", policy: "Política de devoluciones"
    },
    it: {
      heading: "Scegli la tua moto", brand: "Marca", model: "Modello", year: "Anno",
      color: "Colore", colorHint: "Facoltativo: colore base della tua moto o richieste per il design",
      pickBrand: "Scegli la marca", pickModel: "Scegli il modello", pickYear: "Scegli l'anno",
      missing: "Scegli prima marca, modello e anno.",
      missingColor: "Indica il colore.",
      notice: "Realizzato secondo le tue scelte. I prodotti personalizzati sono esclusi dal diritto di recesso, quindi controlla bene le tue scelte.", policy: "Politica di restituzione"
    },
    nl: {
      heading: "Kies je motor", brand: "Merk", model: "Model", year: "Bouwjaar",
      color: "Kleur", colorHint: "Optioneel: basiskleur van je motor of wensen voor het ontwerp",
      pickBrand: "Kies merk", pickModel: "Kies model", pickYear: "Kies bouwjaar",
      missing: "Kies eerst merk, model en bouwjaar.",
      missingColor: "Vul de kleur in.",
      notice: "Wordt gemaakt volgens jouw keuzes. Gepersonaliseerde producten zijn uitgesloten van het herroepingsrecht, dus controleer je keuzes goed.", policy: "Retourbeleid"
    }
  };
  var EXTRA = {
    en: { other: "Other / not in the list", bike: "Your bike (brand, model, year)", missingBike: "Please write which bike you have.",
          modellnamn: "Model name on the stickers", text: "Your text", anvandarnamn: "Your username", mnHint: "Optional. Leave empty and we print the model you selected above. Required if your bike is not in the list.", missingText: "Please fill in the text." },
    sv: { other: "Annan / finns inte i listan", bike: "Din motorcykel (märke, modell, årsmodell)", missingBike: "Skriv vilken motorcykel du har.",
          modellnamn: "Modellnamn på dekalerna", text: "Din text", anvandarnamn: "Ditt användarnamn", mnHint: "Valfritt. Lämna tomt så trycker vi modellen du valt ovan. Obligatoriskt om din motorcykel inte finns i listan.", missingText: "Fyll i texten." },
    fr: { other: "Autre / pas dans la liste", bike: "Votre moto (marque, modèle, année)", missingBike: "Indiquez quelle moto vous avez.",
          modellnamn: "Nom du modèle sur les stickers", text: "Votre texte", anvandarnamn: "Votre nom d'utilisateur", mnHint: "Facultatif. Laissez vide et nous imprimons le modèle choisi ci-dessus. Obligatoire si votre moto n'est pas dans la liste.", missingText: "Veuillez saisir le texte." },
    de: { other: "Andere / nicht in der Liste", bike: "Dein Motorrad (Marke, Modell, Baujahr)", missingBike: "Bitte gib an, welches Motorrad du hast.",
          modellnamn: "Modellname auf den Aufklebern", text: "Dein Text", anvandarnamn: "Dein Benutzername", mnHint: "Optional. Leer lassen und wir drucken das oben gewählte Modell. Pflicht, wenn dein Motorrad nicht in der Liste steht.", missingText: "Bitte gib den Text ein." },
    es: { other: "Otra / no está en la lista", bike: "Tu moto (marca, modelo, año)", missingBike: "Indica qué moto tienes.",
          modellnamn: "Nombre del modelo en los adhesivos", text: "Tu texto", anvandarnamn: "Tu nombre de usuario", mnHint: "Opcional. Déjalo vacío e imprimimos el modelo elegido arriba. Obligatorio si tu moto no está en la lista.", missingText: "Escribe el texto." },
    it: { other: "Altra / non in elenco", bike: "La tua moto (marca, modello, anno)", missingBike: "Indica quale moto hai.",
          modellnamn: "Nome del modello sugli adesivi", text: "Il tuo testo", anvandarnamn: "Il tuo nome utente", mnHint: "Facoltativo. Lascia vuoto e stampiamo il modello scelto sopra. Obbligatorio se la tua moto non è in elenco.", missingText: "Inserisci il testo." },
    nl: { other: "Andere / niet in de lijst", bike: "Jouw motor (merk, model, bouwjaar)", missingBike: "Vul in welke motor je hebt.",
          modellnamn: "Modelnaam op de stickers", text: "Jouw tekst", anvandarnamn: "Jouw gebruikersnaam", mnHint: "Optioneel. Laat leeg en we drukken het hierboven gekozen model. Verplicht als je motor niet in de lijst staat.", missingText: "Vul de tekst in." }
  };
  var LANG = (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
  var TXT = ALLA_TXT[LANG] || ALLA_TXT.en;
  var X = EXTRA[LANG] || EXTRA.en;
  for (var k in X) TXT[k] = X[k];
  var ANNAN = "__annan__";
  var CARET = '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></span>';
  var data = null;
  document.documentElement.classList.add("ss-dod-page");

  function dropdown(label, name, formId) {
    var w = document.createElement("div");
    w.className = "product-form__input product-form__input--dropdown ss-dod-field";
    w.innerHTML = '<label class="form__label"></label><div class="select"><select class="select__select" required></select>' + CARET + "</div>";
    w.querySelector("label").textContent = label;
    var s = w.querySelector("select");
    s.name = "properties[" + name + "]";
    s.setAttribute("form", formId);
    return w;
  }
  function fill(sel, placeholder, values) {
    sel.innerHTML = "";
    var o = document.createElement("option");
    o.value = ""; o.textContent = placeholder; o.disabled = true; o.selected = true;
    sel.appendChild(o);
    (values || []).forEach(function (v) {
      var x = document.createElement("option");
      x.value = v; x.textContent = v;
      sel.appendChild(x);
    });
    sel.disabled = !values || !values.length;
  }
  function fillAnnan(sel, placeholder, values) {
    fill(sel, placeholder, values);
    var x = document.createElement("option");
    x.value = ANNAN; x.textContent = TXT.other;
    sel.appendChild(x);
    sel.disabled = false;
  }
  function textfalt(label, name, formId, max) {
    var fc = document.createElement("div");
    fc.className = "product-form__input ss-dod-field ss-dod-color";
    fc.innerHTML = '<label class="form__label"></label><div class="field"><input class="field__input" type="text"></div>';
    fc.querySelector("label").textContent = label + " *";
    var i = fc.querySelector("input");
    i.name = "properties[" + name + "]"; i.maxLength = max || 60; i.required = true;
    i.setAttribute("form", formId);
    return fc;
  }

  function build(form) {
    if (form._ssDod) return;
    // OBS: form.id är INTE id-attributet här — formuläret har ett fält name="id"
    // (variant-id) som skuggar egenskapen. Läs attributet.
    var formId = form.getAttribute("id");
    var box = document.createElement("div");
    box.className = "ss-dod";
    box.innerHTML = '<div class="ss-dod-title"></div>';
    box.querySelector(".ss-dod-title").textContent = TXT.heading;
    var sBrand = null, sModel = null, sYear = null, fBike = null, iBike = null, fYear = null;
    if (cfg.kat) {
      var fBrand = dropdown(TXT.brand, "Brand", formId);
      var fModel = dropdown(TXT.model, "Model", formId);
      fYear = dropdown(TXT.year, "Year", formId);
      box.appendChild(fBrand); box.appendChild(fModel); box.appendChild(fYear);
      sBrand = fBrand.querySelector("select"); sModel = fModel.querySelector("select"); sYear = fYear.querySelector("select");
      fBike = textfalt(TXT.bike, "Bike", formId, 80); fBike.hidden = true;
      iBike = fBike.querySelector("input"); iBike.required = false; iBike.disabled = true;
      box.appendChild(fBike);
    } else {
      box.querySelector(".ss-dod-title").remove();
    }
    var iText = null;
    if (cfg.text && TXT[cfg.text]) {
      var fText = textfalt(TXT[cfg.text], cfg.text === "modellnamn" ? "Model name" : "Text", formId, 40);
      iText = fText.querySelector("input");
      box.appendChild(fText);
      if (cfg.text === "modellnamn" && cfg.kat) {
        // Modellnamnet behövs bara när hojen inte finns i listan (eller kunden vill ha annan text)
        var hint = document.createElement("div");
        hint.className = "ss-dod-hint"; hint.textContent = TXT.mnHint;
        fText.appendChild(hint);
        var lbl = fText.querySelector("label");
        var satt = function (krav) { iText.required = krav; lbl.textContent = TXT.modellnamn + (krav ? " *" : ""); };
        satt(false);
        iText._ssSatt = satt;
      }
    }
    var iColor = null;
    if (cfg.color === "optional" || cfg.color === "required") {
      var fc = document.createElement("div");
      fc.className = "product-form__input ss-dod-field ss-dod-color";
      fc.innerHTML = '<label class="form__label"></label><div class="field"><input class="field__input" type="text" maxlength="120"></div><div class="ss-dod-hint"></div>';
      fc.querySelector("label").textContent = TXT.color + (cfg.color === "required" ? " *" : "");
      iColor = fc.querySelector("input");
      iColor.name = "properties[Color]";
      iColor.setAttribute("form", formId);
      if (cfg.color === "required") iColor.required = true;
      fc.querySelector(".ss-dod-hint").textContent = cfg.color === "required" ? "" : TXT.colorHint;
      box.appendChild(fc);
    }
    /* Undantaget från ångerrätten ska synas före köp (returpolicyn avsnitt 5, 2026-10-02). */
    var notice = document.createElement("div");
    if (cfg.notice === false) notice.hidden = true;
    notice.className = "ss-dod-hint ss-dod-notice";
    notice.style.margin = "0 0 1rem";
    notice.appendChild(document.createTextNode(TXT.notice + " "));
    var pl = document.createElement("a");
    pl.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "policies/refund-policy";
    pl.textContent = TXT.policy;
    pl.target = "_blank"; pl.rel = "noopener";
    notice.appendChild(pl);
    box.appendChild(notice);
    var msg = document.createElement("div");
    msg.className = "ss-dod-msg";
    msg.hidden = true;
    box.appendChild(msg);

    var lista = cfg.kat ? (data[cfg.kat] || {}) : {};
    function annan(pa) {
      // "Annan": dölj år, kräv fritext. Inaktiverade fält skickas inte med i formuläret.
      fBike.hidden = !pa; iBike.disabled = !pa; iBike.required = pa;
      fYear.hidden = pa; sYear.disabled = pa || sYear.options.length <= 1;
      // "Annan" ska inte skickas som Brand/Model, och tom modellruta får inte stoppa köpet
      sBrand.name = sBrand.value === ANNAN ? "" : "properties[Brand]";
      sModel.name = (sModel.value === ANNAN || sBrand.value === ANNAN) ? "" : "properties[Model]";
      sModel.required = !(pa && sBrand.value === ANNAN);
      sYear.required = !pa && !sYear.disabled;
      if (iText && iText._ssSatt) iText._ssSatt(pa);
      if (pa) iBike.focus();
    }
    // Modell visas först när märke är valt, årsmodell först när modell är vald (Filip 2026-10-09)
    function synk() {
      if (!cfg.kat) return;
      fModel.hidden = !sBrand.value || sBrand.value === ANNAN;
      fYear.hidden = fModel.hidden || !sModel.value || sModel.value === ANNAN || sYear.options.length <= 1;
    }
    if (cfg.kat) {
      ["change", "input"].forEach(function (h) {
        sBrand.addEventListener(h, function () { setTimeout(synk, 0); });
        sModel.addEventListener(h, function () { setTimeout(synk, 0); });
      });
      fillAnnan(sBrand, TXT.pickBrand, Object.keys(lista));
      fill(sModel, TXT.pickModel, []);
      fill(sYear, TXT.pickYear, []);
      sBrand.addEventListener("change", function () {
        if (sBrand.value === ANNAN) { fill(sModel, TXT.pickModel, []); fill(sYear, TXT.pickYear, []); annan(true); msg.hidden = true; return; }
        annan(false);
        fillAnnan(sModel, TXT.pickModel, Object.keys(lista[sBrand.value] || {}));
        fill(sYear, TXT.pickYear, []);
        msg.hidden = true;
      });
      sModel.addEventListener("change", function () {
        if (sModel.value === ANNAN) { fill(sYear, TXT.pickYear, []); annan(true); msg.hidden = true; return; }
        annan(false);
        var years = (lista[sBrand.value] || {})[sModel.value] || [];
        fill(sYear, TXT.pickYear, years);
        if (years.length === 1) sYear.value = years[0];
        msg.hidden = true;
      });
      sYear.addEventListener("change", function () { msg.hidden = true; });
      synk();
      if (cfg.marke) {
        var m = Object.keys(lista).filter(function (b) { return b.toLowerCase() === String(cfg.marke).toLowerCase(); })[0];
        if (m) { sBrand.value = m; sBrand.dispatchEvent(new Event("change")); }
      }
    }

    var orsak = "";   // varför köpet stoppades, till besöksmätningen (ss-umami.liquid)
    function ok() {
      if (cfg.kat) {
        var arAnnan = sBrand.value === ANNAN || sModel.value === ANNAN;
        orsak = "hojval";
        if (arAnnan) { if (!iBike.value.trim()) { msg.textContent = TXT.missingBike; msg.hidden = false; return false; } }
        else if (!sBrand.value || !sModel.value || (!sYear.disabled && !sYear.value)) { msg.textContent = TXT.missing; msg.hidden = false; return false; }
      }
      orsak = "text";
      if (iText && iText.required && !iText.value.trim()) { msg.textContent = TXT.missingText; msg.hidden = false; return false; }
      orsak = "farg";
      if (iColor && iColor.required && !iColor.value.trim()) { msg.textContent = TXT.missingColor; msg.hidden = false; return false; }
      return true;
    }
    // Rides product-form.js lyssnar på submit på formuläret; vi stoppar det i
    // capture-fasen innan temat hinner skicka. "ss:varukorg-stoppad" läses av ss-umami.liquid.
    form.addEventListener("submit", function (e) {
      if (!ok()) {
        e.preventDefault(); e.stopImmediatePropagation(); box.scrollIntoView({ block: "center", behavior: "smooth" });
        try { document.dispatchEvent(new CustomEvent("ss:varukorg-stoppad", { detail: { orsak: orsak, form: form } })); } catch (x) {}
      }
    }, true);

    // Placering: överst bland valen — före variantväljaren (eller vår färg-dropdown),
    // annars före kvantiteten.
    var info = form.closest(".product__info-container") || document;
    // Färgväljaren (.ss-color) står alltid överst (Filip 2026-10-09): hojväljaren läggs direkt efter den,
    // dvs. före variantväljaren. ss-finish-picker.js hoppar över .ss-dod när den letar efter färgen.
    var vsAnchor = info.querySelector("variant-selects");
    var anchor = vsAnchor || info.querySelector(".product-form__quantity") || form;
    anchor.parentNode.insertBefore(box, anchor);
    form._ssDod = box;
  }

  function ensure() {
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    Array.prototype.forEach.call(forms, function (f) {
      if (f.closest("quick-add-modal, .quick-add")) return;
      if (!f.getAttribute("id") || f._ssDod) return;
      build(f);
    });
  }
  function start() {
    fetch(cfg.data).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d) return;
      data = d;
      ensure();
      new MutationObserver(function () { ensure(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    }).catch(function () {});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
